import { DynamicSEO } from '../components/seo';
import Layout from '../components/Layout';

export default function TermsPage() {
  return (
    <Layout>
      <DynamicSEO
        meta={{
          title: "Terms of Service - NameExplorer",
          description: "Read NameExplorer's terms of service and usage guidelines.",
          type: "website"
        }}
      />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Usage Terms</h2>
            <p className="text-gray-600">
              By using NameExplorer, you agree to these terms and conditions. Our
              service is provided "as is" without warranties of any kind.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Content Usage</h2>
            <p className="text-gray-600">
              All content on NameExplorer is protected by copyright. You may share
              content for personal, non-commercial use with proper attribution.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">User Conduct</h2>
            <p className="text-gray-600">
              Users must not misuse our services or attempt to access them using
              automated methods without our permission.
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}